'use strict';
import get from 'lodash/get';
import has from 'lodash/has';
import isNumber from 'lodash/isNumber';
import omit from 'lodash/omit';
import set from 'lodash/set';
import React from 'react';
import {buildFormHOC} from '../../../components/forms/Form';
import {INPUT_TYPES} from '../../../components/forms/FormField';
import {createGeoJsonPoint} from '../../../core-utilities/geo/utils';
import {AssetFormView} from './AssetFormView';


// TODO: add a fetch button and support for injected the results into the internal form model
//  - Allow the user to look up the address from coords or coords from address and add this info to the form.
export const AssetFormComponent = buildFormHOC(AssetFormView, {
  fields: [{
    property: 'name',
    type: INPUT_TYPES.text,
    constraints: {nullable: false},
    canEdit: true,
    useError: true,
  }, {
    property: 'identifier',
    type: INPUT_TYPES.text,
    constraints: {nullable: false},
    canEdit: true,
    useError: true,
  }, {
    property: 'address',
    getValue: getAddress,
    type: INPUT_TYPES.text,
    constraints: {nullable: true},
    canEdit: true,
    useError: true,
  }, {
    property: 'latitude',
    getValue: getLatitude,
    type: INPUT_TYPES.number,
    constraints: {
      nullable: true,
      isDecimal: true,
      min: -90,
      max: 90,
    },
    canEdit: true,
    useError: true,
  }, {
    property: 'longitude',
    getValue: getLongitude,
    type: INPUT_TYPES.number,
    constraints: {
      nullable: true,
      isDecimal: true,
      min: -180,
      max: 180,
    },
    canEdit: true,
    useError: true,
  }],
  serializeModel,
});

function serializeModel(dirtyModel, model) {
  const hasAddressUpdate = has(dirtyModel, 'address');
  const hasLatitudeUpdate = has(dirtyModel, 'latitude');
  const hasLongitudeUpdate = has(dirtyModel, 'longitude');

  if (!hasAddressUpdate && !hasLatitudeUpdate && !hasLongitudeUpdate) {
    return dirtyModel;
  }

  const existingAddress = getAddress(model);
  const existingLatitude = getLatitude(model);
  const existingLongitude = getLongitude(model);

  const newAddressExists = hasAddressUpdate ? !!dirtyModel.address : !!existingAddress;
  const newLatitudeExists = hasLatitudeUpdate ? isNumber(dirtyModel.latitude) : isNumber(existingLatitude);
  const newLongitudeExists = hasLongitudeUpdate ? isNumber(dirtyModel.longitude) : isNumber(existingLongitude);

  if (newAddressExists || (newLatitudeExists && newLongitudeExists)) {
    const nextGeo = newLatitudeExists && newLongitudeExists
      ? createGeoJsonPoint(
        hasLatitudeUpdate ? dirtyModel.latitude : existingLatitude,
        hasLongitudeUpdate ? dirtyModel.longitude : existingLongitude,
      )
      : createGeoJsonPoint(null, null);

    if (newAddressExists) {
      set(nextGeo, 'properties.address', hasAddressUpdate ? dirtyModel.address : existingAddress);
    }

    dirtyModel.geo = nextGeo;
  } else {
    dirtyModel.geo = null;
  }

  return omit(dirtyModel, ['address', 'latitude', 'longitude']);
}

function getAddress(model) {
  return get(model, 'geo.properties.address');
}

function getLatitude(model) {
  return get(model, 'geo.geometry.coordinates[1]');
}

function getLongitude(model) {
  return get(model, 'geo.geometry.coordinates[0]');
}



// WEBPACK FOOTER //
// ./src/js/assets/components/AssetForm/AssetFormComponent.js